<template>
  <div class="product-aside-heading">
    <div class="product-aside-heading-top">
      <div class="product-aside-heading-pre">
        <span v-if="product.product_type" class="product-aside-heading-tag">{{ product.product_type }}</span>
        <h1 class="product-aside-heading-heading">{{ product.shopify_title }}</h1>
        <slot></slot>
      </div>
      <div class="product-aside-heading-like">
        <addToWishlist :id="product.shopify_id" :title="product.shopify_title" />
      </div>
    </div>

  </div>
</template>

<script>
import addToWishlist from "./addToWishlist.vue";

export default {
  components: { addToWishlist },
  props: {
    product: Object
  }
};
</script>
